module.exports = __webpack_public_path__ + "img/cover.3c5dce2c.jpg";